import React from 'react';
import { Input, InputCurrency } from './styles';

interface Props {
  value: string;
  onChangeText: (text: string) => void;
  type?: string;
  inputMode?: "search" | "text" | "email" | "tel" | "url" | "none" | "numeric" | "decimal";
}

const FormInput: React.FC<Props> = ({ onChangeText, value, type = "text", inputMode = 'text' }) => {
  if (type === 'currency') {
    return <InputCurrency
      type={type}
      defaultValue={value}
      decimalsLimit={2}
      onValueChange={(value, name) => {
        onChangeText(value || "")
      }}
      inputMode={inputMode}
    />
  }

  return <Input
    type={type}
    value={value}
    onChange={(e) => {
      onChangeText(e.currentTarget.value)
    }}
    inputMode={inputMode}
  />;
}

export default FormInput;